import React, { useEffect, useState } from "react";
import moment from "moment";
import { Badge, Form } from "react-bootstrap";
import { useParams } from "react-router";
import { studyOtherSettingsServices } from "../../../APIServices/studyOtherSettingsServices";
import UpdateStatement from "./UpdateStatement";
import UseToggle from "../../../Hooks/UseToggle";

const InvestigatorSignature = () => {
  const { studyId } = useParams();
  const GeneratedDate = moment(new Date()).format("DD-MMM-YYYY | HH:mm:ss");
  const [reportLogo, setReportLogo] = useState("");
  const [reportHeaders, setReportHeaders] = useState([]);
  const [reportFooters, setReportFooters] = useState([]);
  const { toggle, setToggle } = UseToggle();

  const existingStatementDetails = `Investigator’s signature on this section indicates that he/she has reviewed the corrected/additional data associated with the case report forms for this subject and has determined that the data are accurate and are consistent with supporting source documentation.`;
  
  const getReportStudyMetadataData = async () => {
    let data = await studyOtherSettingsServices.getReportStudyMetadataData(
      studyId
    );
    let reportData = data?.data || [];
    let headerData =
      reportData?.find((item) => item.type === "header")?.headerData || [];
    let footerData =
      reportData?.find((item) => item.type === "footer")?.footerData || [];
    let logoData = reportData?.find((item) => item.type === "logo");
    setReportHeaders(headerData);
    setReportFooters(footerData);
    setReportLogo(logoData);
  };

  useEffect(() => {
    getReportStudyMetadataData();
  }, []);

  return (
    <>
      <div className="overflow-auto" style={{ height: "calc(100vh - 146px)" }}>
        <div className="w-75 mx-auto p-3">
          <div className="border br3 overflow-hidden">
            <div className="hstack justify-content-between p-4 border-bottom bg-light">
              <div>
                {reportHeaders?.length > 0 &&
                  reportHeaders?.map((item, index) => (
                    <p
                      key={index}
                      className="m-0 fw-bold"
                      style={{ fontSize: 12 }}
                    >
                      {item?.text || "Company name"}
                    </p>
                  ))}
                <p className="m-0 fw-bold" style={{ fontSize: 12 }}>
                  Form Name: XYZ
                </p>
                <p className="m-0 fw-bold" style={{ fontSize: 12 }}>
                  Form Version: V x.x.x
                </p>
                <p className="m-0 fw-bold" style={{ fontSize: 12 }}>
                  Generated On: {GeneratedDate}
                </p>
              </div>
              <img
                src={reportLogo?.logo || ""}
                alt="Company Logo"
                style={{
                  width: reportLogo?.width || 150,
                  height: reportLogo?.height || 80,
                }}
              />
            </div>
            <div className="p-4">
              <div className="bg-light border rounded p-2 position-relative">
                <Badge
                  className="position-absolute text-muted bg-success-subtle br3"
                  style={{ top: -10, left: 20 }}
                >
                  STATEMENT
                </Badge>
                <div
                  className="p-3 CP"
                  title="Click for update statement"
                  onClick={setToggle}
                >
                  <Form.Group className="mb-2 text-center">
                    <Form.Label
                      className="fw-bold mb-1"
                      style={{ fontSize: 18 }}
                    >
                      INVESTIGATOR SIGNATURE
                    </Form.Label>
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <Form.Label className="CP">
                      {existingStatementDetails}
                    </Form.Label>
                  </Form.Group>
                  <div className="text-end">
                    <button className="updateProfile" disabled>
                      Signature
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-4">
              <div className="bg-light border rounded p-2 position-relative">
                <Badge
                  className="position-absolute text-muted bg-success-subtle br3"
                  style={{ top: -10, left: 20 }}
                >
                  1. CORRECTION/ADDITION
                </Badge>
                <div className="p-3">
                  <Form.Label className="fw-bold m-0" style={{ fontSize: 15 }}>
                    DATA CORRECTION/ADDITION IN CASE REPORT FORM.
                  </Form.Label>
                  <Form.Group className="mb-2">
                    <Form.Label>
                      Data correction or addition in the Case Report Form after
                      previous signature.
                    </Form.Label>
                  </Form.Group>
                  <div className="text-end">
                    <button className="updateProfile" disabled>
                      Signature
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-4">
              <div className="bg-light border rounded p-2 position-relative">
                <Badge
                  className="position-absolute text-muted bg-success-subtle br3"
                  style={{ top: -10, left: 20 }}
                >
                  2. CORRECTION/ADDITION
                </Badge>
                <div className="p-3">
                  <Form.Label className="fw-bold m-0" style={{ fontSize: 15 }}>
                    DATA CORRECTION/ADDITION IN CASE REPORT FORM.
                  </Form.Label>
                  <Form.Group className="mb-2">
                    <Form.Label>
                      Data correction or addition in the Case Report Form after
                      previous signature.
                    </Form.Label>
                  </Form.Group>
                  <div className="text-end">
                    <button className="updateProfile" disabled>
                      Signature
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-4 border-top bg-light">
              <div className="hstack justify-content-between">
                <Form.Label className="m-0">{reportFooters?.title1}</Form.Label>
                <Form.Label className="m-0">Page X of Y</Form.Label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <UpdateStatement
        SHOW={!toggle}
        HIDE={setToggle}
        Title={"Upadate Statement"}
        existingStatementDetails={existingStatementDetails}
      />
    </>
  );
};

export default InvestigatorSignature;
